import axios from 'axios';
import {
  QueryClient,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { GetDistributionChannelsCacheKey } from '../queries';

enum DeleteDistributionChannelCacheKey {
  DeleteDistributionChannel = 'DELETE_DISTRIBUTION_CHANNEL',
}

const deleteDistributionChannelMutation = async (channelId: number) => {
  return axios.delete(`/api/distribution-channels/${channelId}`);
};

export const useDeleteDistributionChannelMutation = (teamId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [
      DeleteDistributionChannelCacheKey.DeleteDistributionChannel,
      teamId,
    ],
    mutationFn: (channelId: number) =>
      deleteDistributionChannelMutation(channelId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          GetDistributionChannelsCacheKey.GetDistributionChannels,
          teamId,
        ],
      });
    },
  });
};
